import * as React from 'react';
import { noop } from 'lodash';
import { CardView } from 'design-system/CardView';
import useStyles from 'hooks/useStyles';
import { useAppSelector } from 'store/hooks';
import { SubscriptionScreenContext } from 'features/subscriptions/context/subscriptionScreenContext';
import SubscriptionScreenListHeader from 'features/subscriptions/components/SubscriptionScreenListHeader';
import createStyleSheets from 'utils/createStyleSheets';
import { rem } from 'design-system/values';
const WalkthroughSubscriptionScreenItem = ({ subscription }) => {
    const styles = useStyles(styleSet);
    const subscriptionTransactions = useAppSelector((store) => store.subscriptions.subscriptionTransactions);
    const isFetching = useAppSelector((store) => store.subscriptions.isFetchingSubscriptionsTransactions);
    const contextValue = React.useMemo(() => ({
        editing: false,
        isFetching,
        data: subscription,
        hasData: !!subscriptionTransactions.length,
        name: subscription?.customName || subscription?.merchantInfo?.displayName,
        hideAddMoreTxnsButton: true,
    }), [isFetching, subscription, subscriptionTransactions.length]);
    return (<CardView noMargin style={styles.container} pointerEvents="none">
        <SubscriptionScreenContext.Provider value={contextValue}>
          <SubscriptionScreenListHeader onDone={noop} onEdit={noop} noMarginHorizontal editPrediction={noop} addPrediction={noop}/>
        </SubscriptionScreenContext.Provider>
      </CardView>);
};
export default WalkthroughSubscriptionScreenItem;
const styleSet = createStyleSheets((colors) => ({
    container: {
        marginTop: rem(8),
        marginHorizontal: rem(12),
        paddingTop: rem(16),
        paddingHorizontal: rem(4),
        opacity: 1,
        backgroundColor: colors.background.dark,
    },
}));
